import React from "react";
import Msrp from "Shared/Msrp";
import "./SidebarMSRP.scss";

interface Props {
    vin: string;
}

export const SidebarMSRP = ({ vin }: Props) => {
    return (
        <div className={`Sidebar__MSRP`}>
            <Msrp vin={vin} />
        </div>
    );
};

export default SidebarMSRP;
